/**
 *
 * App.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import PrivateRoute from 'components/PrivateRoute';
import PublicRoute from 'components/PublicRoute';
import Routes from 'config/routes';
import HomePage from 'containers/HomePage/Loadable';
import NotFoundPage from 'containers/NotFoundPage';
// import Auth from 'containers/Auth';

import LegacyCartPage from 'containers/LegacyCartPage/Switch';
import CheckoutSwitch from 'containers/Checkout/Switch';

import AddressBookPage from 'containers/Account/AddressBookPage/Loadable';
import PasswordResetPage from 'containers/Account/PasswordResetPage/Loadable';
import ProfilePage from 'containers/Account/ProfilePage/Loadable';
import WalletPage from 'containers/Account/WalletPage/Loadable';
import LegacyOrdersPage from 'containers/Account/LegacyOrdersPage/Loadable';
import BlackfridayPage from 'containers/StaticPage/Blackfriday/Loadable';
import CyberMondayPage from 'containers/StaticPage/Cybermonday/Loadable';
import EndOfYearPage from 'containers/StaticPage/EndOfYear/Loadable';
import BusinessPage from 'containers/StaticPage/BusinessPage/Loadable';
import FaqPage from 'containers/StaticPage/FaqPage/Loadable';
import TermsAndConditionsPage from 'containers/StaticPage/TermsAndConditionsPage/Loadable';
import ContactUsPage from 'containers/StaticPage/ContactUsPage/Loadable';
import StoresPage from 'containers/StaticPage/StoresPage/Loadable';
import ProhibitedItemsPage from 'containers/StaticPage/ProhibitedItemsPage/Loadable';
import HowItWorksPage from 'containers/StaticPage/HowItWorksPage/Loadable';
import LynksVsEdfa3ly from 'containers/StaticPage/LynksVsEdfa3ly/Loadable';
import CashbackPage from 'containers/StaticPage/CashbackPage/Loadable';
import PromotionPage from 'containers/Promotion/Loadable';
import PromotionsPage from 'containers/Promotions/Loadable';
import ThankYouPage from 'containers/Checkout/ThankYouPage/Loadable';
import HealthCheck from 'containers/HealthCheckPage/Loadable';
import OrdersHistory from 'containers/OrdersHistory/Loadable';
import OrdersHistoryShow from 'containers/OrdersHistory/OrdersHistoryShow/Loadable';

// eslint-disable-next-line react/prefer-stateless-function
class App extends React.Component {
  render() {
    return (
      <Switch>
        <Redirect exact from={Routes.Login} to={Routes.Cart} />
        <Redirect exact from={Routes.Register} to={Routes.Cart} />
        <Redirect exact from={Routes.ForgetPassword} to={Routes.Cart} />
        <PublicRoute exact path={Routes.Home} component={HomePage} />
        <PublicRoute exact path={Routes.Blackfriday} component={BlackfridayPage} />
        <PublicRoute exact path={Routes.CyberMonday} component={CyberMondayPage} />
        <PublicRoute exact path={Routes.EndOfYear} component={EndOfYearPage} />
        <PublicRoute exact path={Routes.Business} component={BusinessPage} />
        <PublicRoute exact path={Routes.Contact} component={ContactUsPage} />
        <PublicRoute exact path={Routes.HowItWorks} component={HowItWorksPage} />
        <PublicRoute exact path={Routes.Cart} component={LegacyCartPage} />
        <PublicRoute exact path={Routes.CartEdit} component={LegacyCartPage} />
        <PublicRoute exact path={Routes.Promotions} component={PromotionsPage} />
        <PublicRoute exact path={Routes.PromotionPage} component={PromotionPage} />
        <PrivateRoute exact path={Routes.Tracking} component={OrdersHistory} />
        <PrivateRoute exact path={Routes.TrackingShow} component={OrdersHistoryShow} />
        <PrivateRoute exact path={Routes.OrdersHistory} component={OrdersHistory} />
        <PrivateRoute exact path={Routes.OrdersHistoryShow} component={OrdersHistoryShow} />
        <Redirect exact from={Routes.Account} to={Routes.AccountProfile} />
        <PrivateRoute
          exact
          path={Routes.AccountProfile}
          component={ProfilePage}
        />
        <PrivateRoute
          exact
          path={Routes.AccountAddressBook}
          component={AddressBookPage}
        />
        <PrivateRoute
          exact
          path={Routes.AccountWallet}
          component={WalletPage}
        />
        <PrivateRoute
          exact
          path={Routes.AccountLegacyOrders}
          component={LegacyOrdersPage}
        />
        <PublicRoute
          exact
          path={Routes.AccountPasswordReset}
          component={PasswordResetPage}
        />
        <PrivateRoute exact path={Routes.ThankYou} component={ThankYouPage} />
        <PrivateRoute exact path={Routes.LiteCheckout} component={CheckoutSwitch} />
        <PrivateRoute exact path={Routes.Checkout} component={CheckoutSwitch} />
        <PrivateRoute
          exact
          path={Routes.typeOnlyCheckout}
          component={CheckoutSwitch}
        />
        {/* <PublicRoute
          exact
          path={Routes.Login}
          component={() => <Auth isPage contentFor="login" />}
        />
        <PublicRoute
          exact
          path={Routes.Register}
          component={() => <Auth isPage contentFor="register" />}
        />
        <PublicRoute
          exact
          path={Routes.ForgetPassword}
          component={() => <Auth isPage contentFor="forgetpass" />}
        /> */}
        <PublicRoute
          exact
          path={Routes.TermsAndConditions}
          component={TermsAndConditionsPage}
        />
        <PublicRoute exact path={Routes.Faq} component={FaqPage} />
        <PublicRoute exact path={Routes.Stores} component={StoresPage} />
        <PublicRoute
          exact
          path={Routes.ProhibitedItems}
          component={ProhibitedItemsPage}
        />
        <PublicRoute exact path={Routes.LynksVsEdfa3ly} component={LynksVsEdfa3ly} />
        <PublicRoute exact path={Routes.CashbackPage} component={CashbackPage} />
        <PublicRoute exact path={Routes.HealthCheck} component={HealthCheck} />

        <PublicRoute component={NotFoundPage} />
      </Switch>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./app/containers/App/index.js